var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.826172C4.486 0.826172 0 5.31223 0 10.8262C0 16.3402 4.486 20.8262 10 20.8262C15.514 20.8262 20 16.3402 20 10.8262C20 5.31223 15.514 0.826172 10 0.826172ZM10 19.008C5.48848 19.008 1.81818 15.3377 1.81818 10.8262C1.81818 6.31478 5.48848 2.64435 10 2.64435C14.5115 2.64435 18.1818 6.31478 18.1818 10.8262C18.1818 15.3377 14.5115 19.008 10 19.008Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 5.0686C9.33164 5.0686 8.788 5.6126 8.788 6.28126C8.788 6.94932 9.33164 7.49284 9.99988 7.49284C10.6681 7.49284 11.2118 6.94932 11.2118 6.28126C11.2118 5.6126 10.6681 5.0686 9.99988 5.0686Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.31102C9.49794 9.31102 9.09091 9.71805 9.09091 10.2201V15.6747C9.09091 16.1767 9.49794 16.5837 10 16.5837C10.5021 16.5837 10.9091 16.1767 10.9091 15.6747V10.2201C10.9091 9.71805 10.5021 9.31102 10 9.31102Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButton);
export default __webpack_public_path__ + "static/media/info_button.44a2d13511f422afbd16f9f007d0b637.svg";
export { ForwardRef as ReactComponent };